import { ArrowRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import Brand from "@/components/Brand";
import OperatorStats from "@/components/OperatorStats";
import Manifest from "@/components/Manifest";

const MAILTO = "mailto:hello@traeva.ie?subject=Bearing%20request&body=Brand%20website%3A%20";

export default function About() {
  return (
    <main data-testid="about-page" className="pt-[88px] md:pt-[72px]">
      {/* HERO */}
      <section className="border-b border-line bg-paper">
        <div className="max-w-[1280px] mx-auto px-6 lg:px-10 pt-8 sm:pt-12 lg:pt-16 pb-14">
          <Reveal>
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-coral flex items-center gap-3.5 mb-5">
              <span className="w-9 h-px bg-coral" />
              About <Brand />
            </p>
          </Reveal>
          <Reveal delay={0.05}>
            <h1 className="font-serif-i italic text-[44px] sm:text-6xl lg:text-[80px] text-ink leading-[.98] tracking-[-.035em] max-w-5xl mb-7">
              Built by someone who has{" "}
              <em className="text-navy-mid">actually done this.</em>
            </h1>
          </Reveal>
          <Reveal delay={0.12}>
            <p className="text-[16px] font-light leading-[1.78] max-w-[640px] text-ink-muted">
              <Brand /> is what gets built when an experienced Amazon EU operator chooses to work
              for a small number of consumer brands instead of a large company. One operator.
              Three brand partners per year. <strong className="text-ink font-medium">Depth is the product.</strong>
            </p>
          </Reveal>
        </div>
      </section>

      {/* OPERATOR STATS + QUOTES */}
      <OperatorStats />

      {/* MANIFEST — full */}
      <Manifest variant="dark" />

      {/* CLOSING */}
      <section className="bg-paper" data-testid="about-cta-section">
        <div className="max-w-[1280px] mx-auto px-6 lg:px-10 py-16 sm:py-20 lg:py-24">
          <Reveal>
            <h2 className="font-serif-i italic text-[40px] sm:text-5xl lg:text-[64px] leading-[.98] tracking-[-.035em] text-ink max-w-4xl">
              Three brands per year.
              <br />
              <em className="text-coral">Yours might be one of them.</em>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-12">
              <a
                href={MAILTO}
                data-testid="about-cta"
                className="inline-flex items-center gap-2 bg-coral text-white text-[14px] font-medium px-8 py-4 transition-transform hover:-translate-y-0.5 hover:bg-coral-dark"
              >
                Request your free Bearing <ArrowRight size={16} strokeWidth={1.6} />
              </a>
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
